import { get, isArray } from 'lodash';
import * as Constants from '../../constants';
import { getParsedAccountPlans } from './responseParser';

const resetState = {
  isError: false,
  errors: [],
  isFormSubmissionSuccessful: false,
  isCreateError: false,
  createErrorMsg: '',
  isUpdateError: false,
  updateErrorMsg: '',
  isFetchingAccountPlans: false,
  isFetchingOrganization: false,
  isCreatingOrganization: false,
  isUpdatingOrganization: false,
};

const initialState = {
  ...resetState,
  isLoading: false,
  isListError: false,
  isFormLoadingError: false,
  isFormValidationError: false,
  isCreateError: false,
  isUpdateError: false,
  createErrorMsg: '',
  updateErrorMsg: '',
  isFetchingAccountPlans: false,
  isFetchingOrganization: false,
  isCreatingOrganization: false,
  isUpdatingOrganization: false,
  organizationNameUnique: true,
  isFormSubmissionSuccessful: false,
  organizations: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
};

const getValidationErrorMessage = (payload) => {
  const validationErrors = get(payload, 'error.detail.validationErrors', []);
  let errorMsg = '';
  if (isArray(validationErrors)) {
    validationErrors.forEach(item => {
      errorMsg += item.error;
    });
  }
  return errorMsg;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
      };
    case Constants.APP_LOADING:
      return {
        ...state,
        ...resetState,
        isLoading: action.isLoading,
      };
    case Constants.ORGANIZATIONS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        organizations: action.payload,
      };
    case Constants.ORGANIZATIONS_GET_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.ORGANIZATION_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        organizations: action.payload,
      };
    case Constants.ORGANIZATION_LIST_GET_ERROR:
      return {
        ...state,
        isLoading: false,
        isListError: true,
      };
    case Constants.ORGANIZATION_GET_REQUEST:
      return {
        ...state,
        isFetchingOrganization: true,
      };
    case Constants.ORGANIZATION_GET_SUCCESS:
      return {
        ...state,
        isFetchingOrganization: false,
        organizationDetails: action.payload,
      };
    case Constants.ORGANIZATION_GET_ERROR:
      return {
        ...state,
        isFetchingOrganization: false,
        isFormLoadingError: true,
      };
    case Constants.ACCOUNTPLANS_GET_REQUEST:
      return {
        ...state,
        isFetchingAccountPlans: true,
      };
    case Constants.ACCOUNTPLANS_GET_SUCCESS:
      return {
        ...state,
        isFetchingAccountPlans: false,
        accountPlans: getParsedAccountPlans(action.payload.d.results),
      };
    case Constants.ACCOUNTPLANS_GET_ERROR :
      return {
        ...state,
        isFetchingAccountPlans: false,
        isFormLoadingError: true,
      };
    case Constants.ORGANIZATION_NAME_UNIQUE_REQUEST:
      return {
        ...state,
        organizationNameUnique: true,
      };
    case Constants.ORGANIZATION_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        organizationNameUnique: action.payload.d.result,
      };
    case Constants.ORGANIZATION_NAME_UNIQUE_ERROR:
      return {
        ...state,
        organizationNameUnique: false,
        isFormValidationError: true,
      };
    case Constants.ORGANIZATION_CREATE_REQUEST:
      return {
        ...state,
        isCreatingOrganization: true,
      };
    case Constants.ORGANIZATION_CREATE_SUCCESS:
      return {
        ...state,
        isCreatingOrganization: false,
        isFormSubmissionSuccessful: true,
        organizationDetails: action.payload,
      };
    case Constants.ORGANIZATION_CREATE_ERROR: {
      const createErrorMsg = getValidationErrorMessage(action.payload);
      return {
        ...state,
        isCreatingOrganization: false,
        isCreateError: true,
        ...(createErrorMsg ? { createErrorMsg } : {}),
      };
    }
    case Constants.ORGANIZATION_UPDATE_REQUEST:
      return {
        ...state,
        isUpdatingOrganization: true,
      };
    case Constants.ORGANIZATION_UPDATE_SUCCESS:
      return {
        ...state,
        isUpdatingOrganization: false,
        isFormSubmissionSuccessful: true,
        organizationDetails: action.payload,
      };
    case Constants.ORGANIZATION_UPDATE_ERROR: {
      const updateErrorMsg = getValidationErrorMessage(action.payload);
      return {
        ...state,
        isUpdatingOrganization: false,
        isUpdateError: true,
        ...(updateErrorMsg ? { updateErrorMsg } : {}),
      };
    }
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'organization.isLoading');

export const getIsError = (state) => get(state, 'organization.isError');
export const getErrors = state => get(state, 'organization.errors');

export const getOrganizationListTotalElements = (state) => get(state, 'organization.organizations.totalElements');
export const getOrganizationListResults = (state) => get(state, 'organization.organizations.results');

export const getIsListError = (state) => get(state, 'organization.isListError');
export const getIsFormLoadingError = (state) => get(state, 'organization.isFormLoadingError');
export const getIsFormValidationError = (state) => get(state, 'organization.isFormValidationError');

export const getIsFormCreateError = (state) => get(state, 'organization.isCreateError');
export const getCreateErrorMsg = (state) => get(state, 'organization.createErrorMsg');
export const getIsFormUpdateError = (state) => get(state, 'organization.isUpdateError');
export const getUpdateErrorMsg = (state) => get(state, 'organization.updateErrorMsg');

export const getIsFormSubmissionSuccessful = (state) => get(state, 'organization.isFormSubmissionSuccessful');

export const getOrganizationsListTotalPages = (state) => get(state, 'organization.organizations.totalPages');
export const getOrganizationsListTotalElements = (state) => get(state, 'organization.organizations.totalElements');
export const getOrganizationsListResults = (state) => get(state, 'organization.organizations.results');

export const getIsOrganizationNameUnique = (state) => get(state, 'organization.organizationNameUnique');

export const getOrganizationDetails = (state) => get(state, 'organization.organizationDetails');
export const getAccountPlans = (state) => get(state, 'organization.accountPlans');

export const getIsFormLoading = (state, isEditMode) =>
  (isEditMode ?
  (
    get(state, 'organization.isFetchingOrganization') ||
    get(state, 'organization.isFetchingAccountPlans') ||
    get(state, 'organization.isUpdatingOrganization')
  )
  :
  (
    get(state, 'organization.isFetchingAccountPlans') ||
    get(state, 'organization.isCreatingOrganization')
  ));



// WEBPACK FOOTER //
// ./src/reducers/organization/index.js